module.exports = __webpack_public_path__ + "img/presidente.b77ebb57.png";